
import { Component, Vue } from 'nuxt-property-decorator'

@Component({ name: 'ChevronLeftLight' })
export default class ChevronLeftLight extends Vue {}
